export const MANAGER_EMPLOYEES_END_POINT = '/api/Employees/GetHierarchyByManager'
export const ORGANIZATIONS_EMPLOYEES_END_POINT = '/api/Employees/GetHierarchyByOrganization'

export const UPDATE_EMPLOYEE_END_POINT = '/api/Employees/update'
export const MOVE_EMPLOYEE_END_POINT = '/api/ManagerEmployees/MoveEmployee'
export const DELETE_EMPLOYEE_END_POINT = '/api/Employees/delete'
export const ADD_EMPLOYEE_END_POINT = '/api/Employees/add'
export const GET_EMPLOYEES_END_POINT = '/api/Employees/all'
export const EMPLOYEE_ASSIGN_TAG = '/api/Employees/assignTag'
export const EMPLOYEE_REMOVE_TAG = '/api/Employees/removeTag'
export const EMPLOYEE_DELETE_LIST = '/api/Employees/deletelist'
export const EMPLOYEE_ADD_WITH_MANAGER = '/api/Employees/addwithmanager'
export const EMPLOYEES_REMOVE_FROM_TAG = '/api/employees/removeemployeesfromtag'
export const UPLOAD_EMPLOYEES = '/api/employees/uploademployees'
export const EMPLOYEES_EXPORT_EXCEL = '/api/employees/ExportToExcel'
export const EMPLOYEES_UNASSIGNED = '/api/Employees/allunassigned'
export const EMPLOYEES_ASSIGNED = '/api/Employees/allassigned'
export const EMPLOYEES_UPLOAD_APPEND = '/api/employees/uploadappend'



// WEBPACK FOOTER //
// ./src/api/employees/types.js